<div>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="seletTimezone">Select Timezone for Catalog</label></div>
                    <ccl-simple-select ariaLabel="Select Timezone"
                        [listOfItems]="timezoneArr"
                        (valueChange)="sharedService.filterSetup.selectTimezone = $event.value"
                        [value]="sharedService.filterSetup.selectTimezone"
                        [bindValue]="'id'"
                        [bindLabel]="'label'"
                        [isClearable]="false"
                    ></ccl-simple-select>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="timezone">Display Timezone Filter</label>
                    <div class="filter-label">
                        <ccl-toggle-button
                        [title]="sharedService.filterSetup.showTimezoneFilter ? 'Enable' : 'Disable'"
                        [isChecked]="sharedService.filterSetup.showTimezoneFilter"
                        (isCheckedChange)="toggleHTMLEnable($event,'showTimezoneFilter')"
                        >{{ sharedService.filterSetup.showTimezoneFilter ? "Enabled" : "Disabled" }}</ccl-toggle-button
                    >
                    </div>
                </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
        </div>
    </div>
</div>